import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { MutationInputError } from './types'

export const ERROR_FRAGMENT: TypedDocumentNode<MutationInputError> = gql`
  fragment ErrorFragment on Error {
    attribute
    message
  }
`
